<template>
    <ReportNavbar>
        <template #header>

            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">Report</h2>
        </template>
        <form @submit.prevent="filterReportSubmit">
            <div class="bg-white rounded-md p-6">
                <p class="mb-2">Filter Reports</p>

                <div class="grid grid-cols-3 gap-3">


                    <FormMultiselect
                        required
                        :options="coursesOptions"
                        track-key="id"
                        label-key="title"
                        :object="true"
                        v-model="course"
                        :placeholder="'Select Course'"
                    />


                    <FormMultiselect
                        required
                        :options="durationsOptions"
                        track-key="id"
                        label-key="title"
                        :object="true"
                        v-model="duration"
                        :placeholder="'Select Duration'"
                    />


                    <FormMultiselect
                        required
                        :options="yearsOptions"
                        track-key="id"
                        label-key="title"
                        :object="true"
                        v-model="year"
                        :placeholder="'Select Year'"
                    />
                    <div class="flex space-x-4 items-center">
                        <BreezeButton :disabled="isLoading">{{ isLoading ? 'Fetching' : 'Fetch' }} Report</BreezeButton>
                        <p class="text-red-500" v-if="noResults">No results found</p>
                    </div>
                </div>
            </div>
        </form>

        <div class="bg-white rounded-md p-6">
            <breeze-table
                :fields="[
                {'key': 'name', 'label': 'Name'},
                { 'key': 'mobile', 'label': 'Mobile' },
                {'key': 'course', 'label': 'Course Name'},
                {'key': 'paid_amount', 'label': 'Paid Fee'},
                {'key': 'remaining_amount', 'label': 'Remaining Fee'},
                {'key': 'total_discount', 'label': 'Discount'},
                { 'key': 'total_amount', 'label': 'Total Fee' }
                ]"
                :items="reports"
                :canView="true"
            >
                <template #name="data">
                    {{ data.item.student.first_name }}
                    {{ data.item.student.middle_name }}
                    {{ data.item.student.last_name }}
                </template>
                <template #course="data">
                    {{ data.item.course.title }}
                    {{ data.item.courseyear.title }}
                </template>
                <template #mobile="data">
                    {{ data.item.student.mobile }}
                </template>
                <template #paid_amount="{item}">
                    ₹{{(item?.paid_amount??0).toFixed(0)}}
                </template>
                <template #remaining_amount="{item}">
                    ₹{{(item?.remaining_amount??0).toFixed(0)}}
                </template>
                <template #total_discount="{item}">
                    ₹{{(item?.total_discount??0).toFixed(0)}}
                </template>
                <template #total_amount="data">
                    ₹{{ (data?.item?.total_fee ?? 0).toFixed(0) }}
                </template>
            </breeze-table>

        </div>
    </ReportNavbar>

</template>

<script setup>
import BreezeTable from "@/Components/NewTable";
import BreezeButton from "@/Components/Button";
import {computed, defineProps, ref} from "vue";
import axios from "axios";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import ReportNavbar from "@/Pages/Report/ReportNavbar.vue";


const course = ref([]);
const duration = ref([]);
const year = ref([]);
const reports = ref([]);
const isLoading = ref(false);
const noResults = ref(false);

const props = defineProps({
    branch_id: String,
    courses: Object,
    durations: Object,
    years: Object
});

function filterReportSubmit() {
    isLoading.value = true;
    var data = {
        course_year_id: course.value?.id,
        duration_id: duration.value?.id,
        year: year.value?.id
    };
    axios
        .get(route("report.academic.fetch", props.branch_id), {params: data})
        .then(resp => {
            reports.value = resp.data;
            isLoading.value = false;
            noResults.value = !resp.data.length;
        })
        .catch(resp => {
            isLoading.value = false;
        });
}

const coursesOptions = computed(() => {
    var data = [];
    props.courses.forEach(item => {
        data.push({id: item.id, title: item.course.title + " " + item.title});
    });
    return data;
});

const durationsOptions = computed(() => {
    var data = [];
    props.durations.forEach(item => {
        data.push({
            id: item.id,
            title: item.start_month + " - " + item.end_month
        });
    });
    return data;
});
const yearsOptions = computed(() => {
    var data = [];
    props.years.forEach(item => {
        data.push({id: item.toString(), title: item.toString()});
    });
    return data;
});
</script>
